import React from 'react';
import { Link } from 'gatsby';
import Layout from '../components/Layout';
import styles from './index.module.scss';


class IndexPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      easter: false,
    };

    this.easterEgg = this.easterEgg.bind(this);
  }

  easterEgg(e) {
    e.preventDefault();
    this.setState({ easter: true });
  }

  render() {
    const { location } = this.props;
    return (
      <Layout location={location}>
        <div className={styles.wrapper}>
          {/* <div className={styles.logoBlock}>
            <div className={styles.logoBlockInner}>
              <div className={styles.logoText}>
                <p>
                  easter weekend<br />
                  thu 9 to sun 12 april<br />
                  melbourne, australia
                </p>
              </div>
              <img src="/assets/logo.png" className={styles.logo} />
            </div>
          </div> */}
          <img src="/assets/logo.png" className={styles.logoAboveNotice} />
          <div className={styles.notice}>
            <p>Due to COVID-19, we regret to announce that Marxism 2020 will be postponed until later this year.</p>

            <p>This was not an easy decision. The conference is an important contribution to building a left-wing political challenge to the widespread injustices of capitalism. For the many hundreds who attend, the opportunity to hear from activists who are on the frontlines of resistance across the globe as well as learning about the history of revolutions and the workers' movement is a source of inspiration and fuel for our activism.</p>

            <p>However, we are not confident that we will be able to host a conference that is safe for participants in April. It is critical that we take this health crisis seriously, including enacting serious social distancing measures to slow the spread of the virus. We do not want our conference to be a site of exposure or create unnecessary risks.</p>

            <p>We have contacted our international and local guest speakers and most have already confirmed that they will be able to participate in a conference later this year. All tickets will be valid for the new conference dates that we will advertise as soon as possible. Thanks in advance for your understanding.</p>

            <p>Marxism Conference Organising Team</p>
          </div>
{/*
          <div className={styles.buttonBlock}>
            <Link className={styles.button} to="/tickets/">Tickets</Link>
            <Link className={styles.button} to="/program/">Program</Link>
          </div> */}
        </div>
      </Layout>
    );
    }
  }

export default IndexPage;
